import { DEFAULT_CREATED_BY } from 'components/Inputs/CreatedBySelect/constants';
import { IQueryProductsData } from './types';

export const DEFAULT_PRODUCT_QUERY: IQueryProductsData = {
  createdByData: { id: DEFAULT_CREATED_BY, name: DEFAULT_CREATED_BY },
  limit: 100,
  isDeleted: { id: 'false', name: 'notDeleted' },
};
